import {useCallback, useEffect, useState} from 'react'

const subscribers = new Set()

// The number shown after the reveal can be a per-session tracking number, so it
// is kept in memory only (never persisted): every button of the same ad shows
// the one the first click obtained, without a second hit or tracking number.
const revealedPhones = new Map()

const usePhoneReveal = ({adId} = {}) => {
  const [revealedPhone, setRevealedPhone] = useState(() => (adId ? revealedPhones.get(String(adId)) : undefined))

  useEffect(() => {
    if (!adId) return

    const syncRevealedPhone = () => {
      setRevealedPhone(revealedPhones.get(String(adId)))
    }

    syncRevealedPhone()
    subscribers.add(syncRevealedPhone)

    return () => subscribers.delete(syncRevealedPhone)
  }, [adId])

  const rememberRevealedPhone = useCallback(
    reveal => {
      const {phone, phoneTrackingSessionId} = reveal || {}
      const current = revealedPhones.get(String(adId))
      if (!adId || !phone || (current?.phone === phone && current?.phoneTrackingSessionId === phoneTrackingSessionId)) {
        return
      }

      revealedPhones.set(String(adId), {phone, phoneTrackingSessionId})
      subscribers.forEach(syncRevealedPhone => syncRevealedPhone())
    },
    [adId]
  )

  return {revealedPhone, rememberRevealedPhone}
}

export default usePhoneReveal
